import { useEffect, useState } from 'react';

export default function useLocalState(state) {
  const [localState, setLocalState] = useState(state);

  useEffect(() => {
    // set primitives directly
    if (state === null || typeof state !== 'object') {
      setLocalState(state);
      return;
    }

    // compare serialized values
    if (JSON.stringify(localState) === JSON.stringify(state)) return;
    setLocalState(state);
  }, [state]);

  return [localState, setLocalState];
}
